import { defineSlotRecipe } from '@chakra-ui/react';
import { BorderWidths, Colors, Space, TextStyles } from '../../types';

// `base` styles native table elements through descendant selectors on `root` (which
// renders the <table>) — these require the `&` prefix; sizes target the slots.
export const tableSlotRecipe = defineSlotRecipe({
  slots: ['root', 'header', 'body', 'row', 'columnHeader', 'cell', 'caption', 'footer'],
  base: {
    root: {
      background: Colors.SURFACE_PAGE,
      color: Colors.TEXT_EMPHASIS,
      borderColor: Colors.BORDER_DEFAULT,
      textStyle: TextStyles.P2,
      borderCollapse: 'collapse',
      width: 'full',
      textAlign: 'start',
      verticalAlign: 'top',
      '& thead': {
        bg: Colors.SURFACE_INSET,
      },
      '& thead th': {
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 'semibold',
        color: Colors.TEXT_MUTED,
        borderColor: Colors.BORDER_DEFAULT,
        borderBottomWidth: BorderWidths.XS,
      },
      '& tbody td': {
        borderColor: Colors.BORDER_SUBDUED,
        borderBottomWidth: BorderWidths.XS,
      },
      '& tbody tr:last-of-type td': {
        borderColor: 'transparent',
      },
      '& tfoot': {
        borderTopWidth: BorderWidths.XS,
        borderColor: Colors.BORDER_DEFAULT,
        borderBottomWidth: '0px',
        textAlign: 'center',
        bg: Colors.SURFACE_INSET,
        '& td': {
          py: Space.XS,
          borderBottomWidth: '0px',
        },
      },
      '& caption': {
        fontWeight: 'normal',
        m: '0',
      },
    },
  },
  variants: {
    size: {
      // Each size sets the header type (xs/xs/sm); otherwise the size's root textStyle reaches the headers.
      sm: { columnHeader: { p: '2.5', fontSize: 'xs', lineHeight: '4' }, cell: { p: '2.5' }, caption: { p: '2.5' } },
      md: {
        columnHeader: { px: '3', py: '2', fontSize: 'xs', lineHeight: '4' },
        cell: { p: '3' },
        caption: { px: '3', py: '2' },
      },
      lg: {
        columnHeader: { px: '4', py: '3', fontSize: 'sm', lineHeight: '5' },
        cell: { p: '4' },
        caption: { px: '4', py: '3' },
      },
    },
    variant: {
      simple: {
        root: {
          '& th': { color: Colors.TEXT_MUTED, borderColor: Colors.BORDER_DEFAULT },
          '& td': { borderColor: Colors.BORDER_SUBDUED, borderBottom: '1px solid' },
        },
      },
      striped: {
        root: {
          '& tbody tr td': { borderColor: 'transparent' },
          '& tbody tr:nth-of-type(odd) th, & tbody tr:nth-of-type(odd) td': { borderColor: 'transparent' },
          '& tbody tr:nth-of-type(odd) td': { background: Colors.SURFACE_INSET },
        },
      },
      unstyled: {
        root: {
          '& th': { border: 'none' },
          '& td': { border: 'none' },
        },
      },
    },
  },
  defaultVariants: {
    variant: 'simple',
  },
});
